<template>
  <div class="mobile-nav">
    <!-- DeepSea Mobile Nav -->
    <nav class="deepsea-nav" v-if="deepsea">
      <!-- START DeepSea -->
      <ul>
        <!-- DeepSea Home -->
        <li>
          <a href="http://www.deepsea.com">Home</a>
        </li>
        <!-- About - Dropdown -->
        <li class="dropdown" @click="showAboutDropdown = !showAboutDropdown">
          <div class="dropdown-li">
            <a href="#">About</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- About - Dropdown Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showAboutDropdown">
            <li>
              <a href="https://www.deepsea.com/our-history/">Our History</a>
            </li>
            <li>
              <a href="https://careers.seescan.com/deepsea">Careers</a>
            </li>
            <li>
              <a href="https://www.deepsea.com/about-us/">About Us</a>
            </li>
            <li>
              <a href="https://www.deepsea.com/life-at-deepsea/"
                >Life at DeepSea</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/the-deepsea-difference/"
                >The DeepSea Difference</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/our-patents/"
                >Intellectual Property</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/terms-and-conditions/"
                >Terms and Conditions</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/warranty/">Warranty</a>
            </li>
          </ul>
        </transition>
        <!-- Products - Dropdown -->
        <li
          class="dropdown"
          @click="showProductsDropdown = !showProductsDropdown"
        >
          <div class="dropdown-li">
            <a href="#">Products</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- Products - Dropdow Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showProductsDropdown">
            <li>
              <a href="https://www.deepsea.com/quickship/"
                >Product Configurations</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/quickship/#quickship"
                >QuickShip Products</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/quickship/#preconfigured"
                >Pre-Configured Products</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/product-documentation/"
                >Product Documentation</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/faqs/">Product FAQs</a>
            </li>
            <li>
              <a
                href="https://www.deepsea.com/our-services/#optical-measurement"
                >Optical Measurement</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/our-services"
                >Pressure Testing</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/cameras/">Cameras</a>
            </li>
            <li>
              <a href="https://www.deepsea.com/lights"> Lights </a>
            </li>
            <li>
              <a href="https://www.deepsea.com/lasers">Lasers</a>
            </li>
            <li>
              <a href="https://www.deepsea.com/vents"> Relief Valves </a>
            </li>
            <li>
              <a href="https://www.deepsea.com/multiplexer/smarthub/"
                >SmartHub™</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/accessories/brackets/"
                >Brackets</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/technology/">Technology</a>
            </li>
            <li>
              <a
                href="https://www.deepsea.com/accessories/multiray-led-sealite/"
                >Multiray® LED SeaLite®</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/accessories/flexlink/"
                >FleXlink®</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/accessories/seasense-protocol/"
                >SeaSense® Protocol</a
              >
            </li>
          </ul>
        </transition>
        <!-- News - Dropdown -->
        <li class="dropdown" @click="showNewsDropdown = !showNewsDropdown">
          <div class="dropdown-li">
            <a href="#">News</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- News - Dropdown Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showNewsDropdown">
            <li>
              <a href="https://www.deepsea.com/sio-piercam/"
                >Scripps Pier Livestream</a
              >
            </li>
            <li><a href="https://www.deepsea.com/whats-new/">What's New</a></li>
            <li>
              <a href="https://www.deepsea.com/trade-shows/">Trade Shows</a>
            </li>
            <li>
              <a href="https://www.deepsea.com/press-releases/"
                >Press Releases</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/product-change-notices/"
                >Product Change Notices</a
              >
            </li>
          </ul>
        </transition>
        <!-- DeepSea Support - Dropdown -->
        <li
          class="dropdown"
          @click="showSupportDropdown = !showSupportDropdown"
        >
          <div class="dropdown-li">
            <a href="#">Support</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- DeepSea Support - Dropdown Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showSupportDropdown">
            <li><a href="https://www.deepsea.com/contact/">Contact Us</a></li>
            <li>
              <a href="https://www.deepsea.com/product-documentation/"
                >Product Documentation</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/knowledgebase/">Knowledgebase</a>
            </li>
            <li>
              <a
                href="https://www.deepsea.com/knowledgebase/underwater-imaging/"
                >Underwater Imaging</a
              >
            </li>
            <li>
              <a
                href="https://www.deepsea.com/knowledgebase/underwater-lighting/"
                >Underwater Lighting</a
              >
            </li>
            <li>
              <a
                href="https://www.deepsea.com/knowledgebase/technical-resources/"
                >Technical Resources</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/knowledgebase/products-in-use/"
                >Products In Use</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/knowledgebase/design-tools/"
                >Design Tools</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/knowledgebase/pressure-testing/"
                >Pressure Testing</a
              >
            </li>
            <li>
              <a href="https://help.deepsea.com/support/home"
                >Online Product Support</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/return-material-authorization/"
                >Return Material Authorization</a
              >
            </li>
            <li>
              <a href="https://www.deepsea.com/our-representatives/"
                >Our Representatives</a
              >
            </li>
          </ul>
        </transition>
        <li><a href="https://www.deepsea.com/contact/">Request a Quote</a></li>
      </ul>
      <!-- END DeepSea -->
    </nav>
    <!-- SeeScan Mobile Nav -->
    <nav class="seescan-nav" v-else>
      <!-- START SeeScan -->
      <ul>
        <!-- SeeScan Home -->
        <li><a href="http://www.seescan.com">Home</a></li>
        <!-- Our Company - Dropdown -->
        <li class="dropdown" @click="showCoDropdown = !showCoDropdown">
          <div class="dropdown-li">
            <a href="#">Our Company</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- Our Company - Dropdown Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showCoDropdown">
            <li>
              <a href="https://www.seescan.com/about-us/"> About Us </a>
            </li>
            <li>
              <a href="https://www.seescan.com/our-history/"> Our History </a>
            </li>
            <li>
              <a href="https://www.seescan.com/our-campus/"> Our Campus </a>
            </li>
            <li>
              <a href="https://www.seescan.com/terms-and-conditions/">
                Terms &amp; Conditions
              </a>
            </li>
            <li>
              <a href="https://www.seescan.com/intellectual-property/">
                Intellectual Property
              </a>
            </li>
            <li>
              <a href="https://www.seescan.com/covid-19/"> COVID-19 </a>
            </li>
          </ul>
        </transition>
        <!-- SeeScan Careers - Dropdown -->
        <li
          class="dropdown"
          @click="showCareersDropdown = !showCareersDropdown"
        >
          <div class="dropdown-li">
            <a href="#">Careers</a>
            <button class="dropdown-icon">
              <BaseIcon :iconName="dropdown">
                <IconDropdown />
              </BaseIcon>
            </button>
          </div>
        </li>
        <!-- SeeScan Careers - Dropdown Submenu -->
        <transition name="dropdown">
          <ul class="dropdown-links" v-if="showCareersDropdown">
            <li>
              <a href="https://www.seescan.com/life-at-seescan/">
                Life at SeeScan
              </a>
            </li>
            <li>
              <router-link to="/" :active="isActive" @click="setFavicon"
                >Job Opportunities
              </router-link>
            </li>
          </ul>
        </transition>
        <!-- SeeScan Knowledgebase -->
        <li>
          <a href="https://www.seescan.com/knowledgebase/">Knowledgebase</a>
        </li>
        <!-- SeeScan Geo Locating -->
        <li>
          <a href="https://www.seescan.com/geo-locating/">Geo Locating</a>
        </li>
        <!-- SeeScan Our Products -->
        <li><a href="https://www.seescan.com/products/">Our Products</a></li>
        <!-- SeeScan Repair -->
        <li><a href="https://www.seescan.com/repair/">Repair</a></li>
        <!-- SeeScan Contact Us -->
        <li><a href="https://www.seescan.com/contact_us/">Contact Us</a></li>
      </ul>
      <!-- END SeeScan -->
    </nav>
  </div>
</template>

<script>
import BaseIcon from './global/BaseIcon.vue'
import IconDropdown from './icons/IconDropdown.vue'
export default {
  name: 'Mobile Nav',
  components: {
    BaseIcon,
    IconDropdown,
  },
  props: {
    deepsea: {
      type: Boolean,
    },
  },
  data() {
    return {
      showCareersDropdown: false,
      showAboutDropdown: false,
      showContactDropdown: false,
      showKnowledgebaseDropdown: false,
      showOurRepsDropdown: false,
      showProductDocumentation: false,
      showProductsDropdown: false,
      showNewsDropdown: false,
      showSupportDropdown: false,
    }
  },
  methods: {
    setFavicon() {
      const favicon = document.querySelector("[rel='icon']")
      favicon.setAttribute('href', this.$route.meta.icon)
    },
  },
}
</script>

<style scoped>
.mobile-nav {
  color: rgba(255, 255, 255, 0.2);
  position: absolute;
  top: 95px;
  left: 0px;
  width: 100vw;
  margin: 0 auto;
  overflow: visible;
  z-index: 100;
  text-align: left;
}

.deepsea-nav {
  background: #0956a1;
}

.seescan-nav {
  background: #000000;
}

nav ul {
  border-top: 1px solid;
  border-color: rgba(255, 255, 255, 0.2);
  margin: 0;
}

nav ul li {
  display: inline-block;
  width: 100vw;
  border-color: rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid;
  cursor: pointer;
  padding-left: 30px;
}

nav.deepsea-nav ul li:hover,
nav.deepsea-nav ul li:active {
  background: rgba(0, 0, 0, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

nav.seescan-nav ul li:hover,
nav.seescan-nav ul li:active {
  background: rgba(20, 20, 20, 0.8);
  border-color: rgba(255, 255, 255, 0.2);
}

nav ul li a {
  display: block;
  color: white;
  height: 48px;
  line-height: 48px;
}

nav.deepsea-nav ul li:hover a,
nav.deepsea-nav ul li:active a {
  color: #ffda00;
}

nav.seescan-nav ul li:hover a,
nav.seescan-nav ul li:active a {
  color: #5bba47;
}

nav ul li:hover a,
nav ul li:active a {
  background: transparent;
  border-top-style: none;
  text-decoration: none;
}

/* dropdown */
nav ul li.dropdown div.dropdown-li {
  display: flex;
  flex-basis: auto;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding-right: 30px;
}

button.dropdown-icon {
  color: #f2f2f2;
  height: 16px;
  background: transparent;
  border: none;
}

/* nav ul li:hover button.dropdown-icon,
nav ul li:hover button.dropdown-icon:hover {
  background: transparent;
  border: none;
} */
ul.dropdown-links {
  border-top: none;
}

ul.dropdown-links li {
  padding-left: 50px;
}

ul.level-3 li {
  padding-left: 70px;
}
</style>
